(function ($) {
  Drupal.behaviors.desire_formatter = {
    attach: function (context) {
      $('.desire_formatter', context).once(function (idx, element) {
        // Fade in modules for this boutique.
        const hasFadedMod2 = false,
          hasFadedMod3 = false,
          hasFadedMod4 = false,
          hasFadedMod5 = false;
        const $thismodule = $(element);
        const offsetVal = -200;
        const $mod2 = $('#desire_mod2');
        const triggerMod2 = '#desire_mod2';
        const $mod3 = $('#desire_mod3');
        const triggerMod3 = '#desire_mod3';
        const $mod4 = $('#desire_mod4');
        const triggerMod4 = '#desire_mod4';
        const $mod5 = $('#desire_mod5');
        const triggerMod5 = '#desire_mod5';

        // Check if new or old gnav
        if (!$('.basic-menu-formatter-v1').length) {
          $thismodule
            .closest('.page-main.main')
            .siblings('header.page-header')
            .addClass('gnav-old');
        }

        // Fade in modules for this boutique.
        $($mod2, $mod3, $mod4, $mod5).addClass('hideModules');

        // Add class to allow for styling of header for desktop only.
        if ($('body').hasClass('device-pc')) {
          $('body').addClass('desire__boutique-formatter');
        }

        function checkForIE() {
          // Check for Windows.
          if (navigator.platform === 'Win32') {
            $('body').addClass('isWin');
          }
        }

        function checkForSafari() {
          // Check for Safari.
          if (
            navigator.userAgent.indexOf('Safari') !== -1 &&
            navigator.userAgent.indexOf('Chrome') === -1
          ) {
            $('body').addClass('isSafari');
          }
        }

        function checkForFF() {
          // Check for Firefox.
          if (navigator.userAgent.search('Firefox') >= 0) {
            $('body').addClass('isFF');
          }
        }

        function checkForIEEleven() {
          // Check for IE.
          if ($('body').hasClass('ie') || $('body').hasClass('ie-11')) {
            if ($('body').hasClass('isTouch')) {
              $('body').removeClass('isTouch');
            }
          }
        }

        function checkForMobileDevice() {
          // Check for mobile device
          if (
            /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
          ) {
            $('body').addClass('isMobile');
          }
        }

        function checkForIPad() {
          // Check for iPad.
          if (navigator.userAgent.match(/iPad/i) !== null) {
            $('body').addClass('isTouch');
          }
        }

        function makeBoutiqueChecks() {
          checkForIE();
          checkForSafari();
          checkForFF();
          checkForIEEleven();
          checkForMobileDevice();
          checkForIPad();
        }
        makeBoutiqueChecks();

        $(window).on('load', function () {
          // Remove the spinner once page is loaded
          $('.boutiques_spinner_v1_target').fadeOut();

          // Fade in modules for this boutique.
          // Init scrollMagic Controller Class
          const controller = new ScrollMagic.Controller();

          function fadeMod(faded, mod) {
            if (faded === false) {
              faded = true;
              mod.animate(
                {
                  opacity: 1,
                  paddingTop: '0'
                },
                350,
                'easeOutQuad'
              );
            } else {
              return;
            }
          }

          // Init scrollMagic Scene Classes
          const fadeModScene2 = new ScrollMagic.Scene({
            triggerElement: triggerMod2,
            offset: offsetVal
          }).on('start', function () {
            fadeMod(hasFadedMod2, $mod2);
          });
          const fadeModScene3 = new ScrollMagic.Scene({
            triggerElement: triggerMod3,
            offset: offsetVal
          }).on('start', function () {
            fadeMod(hasFadedMod3, $mod3);
          });
          const fadeModScene4 = new ScrollMagic.Scene({
            triggerElement: triggerMod4,
            offset: offsetVal
          }).on('start', function () {
            fadeMod(hasFadedMod4, $mod4);
          });
          const fadeModScene5 = new ScrollMagic.Scene({
            triggerElement: triggerMod5,
            offset: offsetVal
          }).on('start', function () {
            fadeMod(hasFadedMod5, $mod5);
          });

          // Add the scenes
          controller.addScene([fadeModScene2, fadeModScene3, fadeModScene4, fadeModScene5]);
        });
      });
    }
  };
})(jQuery);
